(function () {
  const TEXT_CLASS = "jdgm-verified-text";
  const TEXT_VALUE = "Verified";

  function makeTextNode() {
    const text = document.createElement("span");
    text.className = TEXT_CLASS;
    text.textContent = TEXT_VALUE;
text.style.marginLeft = "0px";
text.style.display = "inline-flex";
text.style.alignItems = "center";
text.style.padding = "2px 6px";
text.style.borderRadius = "999px";
text.style.fontSize = "0.85em";
text.style.fontWeight = "600";
text.style.lineHeight = "1";
text.style.color = "#893CAE";
text.style.background = "rgba(137, 60, 174, 0.10)";
    return text;
  }

  function applyOldWidget(root = document) {
    const wrappers = root.querySelectorAll(".jdgm-rev__buyer-badge-wrapper");

    wrappers.forEach((wrapper) => {
      if (wrapper.parentElement && wrapper.parentElement.querySelector("." + TEXT_CLASS)) return;

      wrapper.insertAdjacentElement("afterend", makeTextNode());
    });
  }

  function applyNewWidget(root = document) {
    const infos = root.querySelectorAll(".jm-review-item .jm-reviewer-info");

    infos.forEach((info) => {
      if (info.querySelector("." + TEXT_CLASS)) return;

      const marker = info.querySelector(
        '[aria-label*="verified" i], [title*="verified" i], [class*="verified"], [class*="badge"], [class*="icon"], svg, [role="img"]'
      );

      if (!marker) return;

      marker.insertAdjacentElement("afterend", makeTextNode());
    });
  }

  function run(root = document) {
    applyOldWidget(root);
    applyNewWidget(root);
  }

  function boot() {
    const rerun = () => {
      requestAnimationFrame(() => run(document));
      setTimeout(() => run(document), 150);
      setTimeout(() => run(document), 600);
    };

    rerun();

    const observer = new MutationObserver(rerun);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();